(() => {
  if (window.detailshopCollectionFilters) return;
  window.detailshopCollectionFilters = true;

  const drawers = document.querySelectorAll('.collection-filters');
  if (!drawers.length) return;

  drawers.forEach((drawer) => {
    const summary = drawer.querySelector('summary');
    const panel = drawer.querySelector('.collection-filters__panel');
    const closeButtons = drawer.querySelectorAll('[data-filter-close]');
    let returnFocus = false;

    const closeDrawer = () => {
      drawer.open = false;
    };

    drawer.addEventListener('toggle', () => {
      summary?.setAttribute('aria-expanded', String(drawer.open));
      document.body.classList.toggle('collection-filter-drawer-open', drawer.open);

      if (drawer.open) {
        returnFocus = true;
        window.requestAnimationFrame(() => panel?.querySelector('[data-filter-close]')?.focus());
      } else if (returnFocus) {
        returnFocus = false;
        summary?.focus();
      }
    });

    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));

    drawer.addEventListener('keydown', (event) => {
      if (!drawer.open) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab' || !panel) return;

      const focusable = [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')];
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  });
})();
